import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class ContractService extends RLBaseService {

	static $inject = ["$resource"];

	constructor(private $resource: ng.resource.IResourceService) {
		super($resource);
	}

	saveSalesSheet(query: Models.ICreateSalesSheetRequest) {
		return this.toRLService<Models.ICreateEntityResponse>("/api/contract/CreateSalesSheet").post(query).$promise;
	}

	getContractAssets(contractID: string, pagingOptions?: Models.IPagingOptions) {
		var data = {
			contractID: contractID,
			pagingOptions: pagingOptions
		};
		return this.toRLService<Models.AdvancedSearchResult>("/api/contract/GetContractAssets").post(data).$promise;
	}

	getContractAssetRelationships(dealID: string, catalogItemRecIDs: number[]) {
		var data = {
			dealID: dealID,
			CatalogItemRecIDs: catalogItemRecIDs
		};
		return this.toRLService<Models.IEntityRelationship>("/api/contract/GetContractCatalogItemRelationships").postArray(data).$promise;
	}

	getContractInventory(contractID: string, pagingOptions?: Models.IPagingOptions) {
		var data = {
			contractID: contractID,
			pagingOptions: pagingOptions
		};
		return this.toRLService<Models.IRecordRelationshipPair>("/api/contract/getcontractinventory").query(data).$promise;
	}

	addContractAssets(contractID: string, assetIDs: number[]) {
		var data = {
			contractID: contractID,
			assetIDs: assetIDs
		};
		return this.toRLService<Models.IJobResponse>("/api/Contract/AddContractAssets").post(data).$promise;
	}

	addContractInventories(contractID: string, inventoryIDs: number[]) {
		var data = {
			contractID: contractID,
			inventoryIDs: inventoryIDs
		};
		return this.toRLService<Models.IJobResponse>("/api/Contract/AddContractInventories").post(data).$promise;
	}


	removeContractAsset(contractID: string, relRecID: number) {
		var data = {
			contractID: contractID,
			relRecID: relRecID
		};
		return this.toRLService<boolean>("/api/contract/removecontractassets").post(data).$promise;
	}

	removeContractInventory(contractID: string, relRecID: number) {
		var data = {
			contractID: contractID,
			relRecID: relRecID
		};
		return this.toRLService<boolean>("/api/contract/removecontractinventories").post(data).$promise;
	}

	deleteRightSet(relationship: Models.IEntityRelationship) {
		var data = {
			relationship: relationship
		};
		return this.toRLService<{ success: boolean }>("/api/contract/deleterightset").post(relationship).$promise;
	}

	createRightSet(templateID: string, parentEntityID: string, charDatas: Models.ICharDatas, assetRecIDs: number[], contactRecIDs: number[]) {
		var data = {
			templateID: templateID,
			parentEntityID: parentEntityID,
			charDatas: charDatas,
			assetRecIDs: assetRecIDs,
			contactRecIDs: contactRecIDs
		};
		return this.toRLService<{ success: boolean; entityID: string }>("/api/contract/createcontractright").post(data).$promise;
	}

	copyRightSet(rightSetID: number) {
		var data = {
			recordID: rightSetID
		};
		return this.toRLService<void>("/api/contract/copyrightset").post(data).$promise;
	}

	getAssociableInvoices(contractRecID: number, amountTemplateIDs: number[], currencyCharValueID: number) {
		var data: Models.IGetAssociableInvoicesRequest = {
			contractID: contractRecID,
			amountTemplateIDs: amountTemplateIDs,
			currencyCharValueID: currencyCharValueID
		};
		return this.toRLService<Models.IAssociableInvoiceResults>("/api/contract/getassociableinvoices").post(data).$promise;
	}

	associateAmountsToInvoice(invoiceID: number, amountIDs: number[]) {
		var data: Models.IAssociateAmountsToInvoiceRequest = {
			invoiceID: invoiceID,
			amountIDs: amountIDs
		};
		return this.toRLService<void>("/api/contract/associateamountstoinvoice").post(data).$promise;
	}

	associateAmountsToNewInvoice(contractID: number, invoiceTemplateID: number, amountIDs: number[]) {
		var data: Models.IAssociateAmountsToNewInvoiceRequest = {
			contractID: contractID,
			invoiceTemplateID: invoiceTemplateID,
			amountIDs: amountIDs
		};
		return this.toRLService<Models.ICreateEntityResponse>("/api/contract/associateamountstonewinvoice").post(data).$promise;
	}

	getFinancials(contractID: string) {
		var data = {
			contractID: contractID
		};
		return this.toRLService<Models.IFinancialSearchDoc>("/api/contract/getfinancials").query(data).$promise;
	}

	GetContractRightAssetRelationships(contractRightRelRecID: number) {
		var data = {
			relRecID: contractRightRelRecID
		};
		return this.toRLService<Models.IEntityRelationship>("/api/contract/GetContractRightAssetRelationships").postArray(data).$promise;
	}

	uploadContractAttachment(contractID: number, fileKey: string, fileName: string, fileDescription: string) {
		var data = {
			contractID: contractID,
			fileKey: fileKey,
			fileName: fileName,
			fileDescription: fileDescription
		};
		return this.toRLService<void>("/api/contract/uploadcontractattachment").post(data).$promise;
	}

	deleteContractAttachment(contractID: number, attachmentID: number) {
		var data = {
			contractID: contractID,
			attachmentID: attachmentID
		};
		return this.toRLService<void>("/api/contract/deletecontractattachment").post(data).$promise;
	}

	deleteContract(contractID: string) {
		var data = {
			entityID: contractID
		};
		return this.toRLService<void>("/api/contract/deletecontract").post(data).$promise;
	}

	getContractRoyalties(contractID: number, filterRelRecID?: number) {
		var data = {
			contractID: contractID,
			filterRelRecID: filterRelRecID
		};
		return this.toRLService<Models.IContractRoyaltyRelationshipPair>("/api/contract/getcontractroyalties").query(data).$promise;
	}

	getContractRoyaltyPayees(contractID: number) {
		var data = {
			contractID: contractID
		};
		return this.toRLService<Models.IEntity>("/api/contract/getcontractroyaltypayees").query(data).$promise;
	}

	getContractRoyaltyIncomeGroups() {
		return this.toRLService<Models.ICharacteristicMetaDataValue>("/api/contract/getcontractroyaltyincomegroups").query().$promise;
	}

	saveRoyalty(royaltyID: string, charDatas: Models.ICharDatas, transRoyaltyRelRecID: number, splits: Models.IRoyaltySplit[]) {
		var data = {
			entityID: royaltyID,
			CharDatas: charDatas,
			transRoyaltyRelRecID: transRoyaltyRelRecID,
			royaltySplits: splits
		};
		return this.toRLService<void>("/api/contract/saveRoyalty").post(data).$promise;
	}

	createRoyalty(transRecID: number, templateID: number, charDatas: Models.ICharDatas, assetRecIDs: number[], splits: Models.IRoyaltySplit[]) {
		var data = {
			transRecID: transRecID,
			templateID: templateID,
			charDatas: charDatas,
			assetRecIDs: assetRecIDs,
			royaltySplits: splits
		};
		return this.toRLService<void>("/api/contract/createroyalty").post(data).$promise;
	}

	deleteRoyalty(royaltyRecID: number) {
		var data = {
			recordID: royaltyRecID
		};
		return this.toRLService<void>("/api/contract/deleteroyalty").post(data).$promise;
	}

	bulkEditDates(rightSetRecIDs: number[], startDateCharID: number, endDateCharID: number, setStartDate: string = null, setEndDate: string = null, adjustStartDate: number = null, adjustEndDate: number = null) {
		var data = {
			rightSetRecIDs: rightSetRecIDs,
			startDateCharID: startDateCharID,
			endDateCharID: endDateCharID,
			setStartDate: setStartDate,
			setEndDate: setEndDate,
			adjustStartDate: adjustStartDate,
			adjustEndDate: adjustEndDate
		};
		return this.toRLService<Models.IRightSetBulkEditResponse>("/api/contract/bulkeditdates").post(data).$promise;
	}

	bulkEditHierarchy(bulkEditMode: number, rightSetRecIDs: number[], characteristicID: number, charValueIDs: number[]) {
		var data = {
			rightSetRecIDs: rightSetRecIDs,
			characteristicID: characteristicID,
			bulkEditMode: bulkEditMode,
			charValueIDs: charValueIDs
		};
		return this.toRLService<Models.IRightSetBulkEditResponse>("/api/contract/bulkedithierarchy").post(data).$promise;
	}

	bulkEditDelete(charTypeID: number, recordID: number, rightSetRecIDs: number[]) {
		var data = {
			charTypeID: charTypeID,
			recordID: recordID,
			rightSetRecIDs: rightSetRecIDs
		};
		return this.toRLService<Models.IRightSetBulkEditResponse>("/api/contract/bulkdelete").post(data).$promise;
	}

	getContractRights(contractID: number, startDate: string, endDate: string, titleKeywords: string,
		filters: any, facetFields: string[], page: number, rows: number, sortDir: number, sortField: string,
		groupBy: string, groupID: number, selectedPaths: { [label: string]: string[] }) {
		var data = {
			contractID: contractID,
			startDate: startDate,
			endDate: endDate,
			titleKeywords: titleKeywords,
			page: page,
			rowCount: rows,
			sortField: sortField,
			sortDir: sortDir,
			filters: filters,
			facetFields: facetFields,
			groupBy: groupBy,
			groupID: groupID,
			selectedPaths: selectedPaths
		};
		return this.toRLService<Models.IGetContractRightsResponse>("/api/contract/getcontractrights").post(data).$promise;
	}


	getContractAssetTitles(contractID: number, getImplicitCatalogItems: boolean = false) {
		var data = {
			contractID: contractID,
			getImplicitCatalogItems: getImplicitCatalogItems
		};
		return this.toRLService<{ data: { [assetID: number]: string } }>("/api/contract/getcontractassettitles").get(data).$promise;
	}

	calculateAllocation(dealID: string, allocationType: number, selectedTemplates: number[]) {
		var data = {
			dealID,
			type: allocationType,
            selectedTemplates
		};
        return this.toRLService<Models.IJobResponse>("/api/contract/calculateallocation").post(data).$promise;
	}

    calculateAmortization(dealID: string, modelID: number, selectedAllocations: string[]) {
		var data = {
            dealID,
            modelID,
            selectedAllocations
		}
        return this.toRLService<Models.IJobResponse>("/api/contract/calculateamortization").post(data).$promise;
	}

	validateFinancials(dealID: string) {
		var data = {
			dealID
		}
		return this.toRLService<Models.IFinancialValidation>("/api/contract/validatefinancials").post(data).$promise;
	}
}
